import Box from "@mui/material/Box";
import { playerHandleSuffix } from "@bw/shared/components";
import type { BookingResponse } from "@bw/shared/types/generated";

/** "Booked by Grace Liu #9153 · {suffix}" (or "Booked by you"), no raw ids. */
export function BookedBy({
  booking,
  myUserId,
  suffix,
}: {
  booking: Pick<BookingResponse, "user_id" | "display_name">;
  myUserId: string | undefined;
  suffix: string;
}) {
  if (booking.user_id && booking.user_id === myUserId) return <>Booked by you · {suffix}</>;
  const host = booking.display_name?.trim();
  if (!host || !booking.user_id) return <>Booked · {suffix}</>;
  return (
    <>
      Booked by {host}{" "}
      <Box component="span" sx={{ color: "text.disabled" }}>
        {playerHandleSuffix(booking.user_id)}
      </Box>{" "}
      · {suffix}
    </>
  );
}
